import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, URL_API } from "../../variable";
import moment from "moment";
import { useParams } from "react-router";

//

function BlogDetailSection() {
  const id = useParams();
  // console.log('iddddddddd',id.id);
  const [article, setArticle] = useState([]);

  useEffect(() => {
    getArticle();
  }, []);

  const getArticle = () => {
    axios.get(URL_API + `auth/admin/articles/${id.id}`).then((response) => {
      console.log(response.data.article);
      if (response.data.status === 200) {
        setArticle(response.data.article);
      }
    });
  };




  return (
    <>
      <br></br> 
      <br></br> 
      <br></br> 
      <br></br> 
      <br></br> 
      <h3>Article Detail</h3>
      <div className="container px-4 px-lg-5 my-5">
        <div className="row gx-4 gx-lg-5 ">
          <div className="col-md-6">
            <img
              className="card-img-top mb-5 mb-md-0"
              src={`https://lync1869.rideshide.com/` + article?.image}
              alt="..."
              height={500}
              width={500}
            />
          </div>
          <div className="col-md-6">
            <div className="small mb-1">&nbsp; &nbsp;</div>
            <h1 className="display-6 fw-bolder">{article?.title}</h1>
            <div className="fs-5 mb-5">
              {/* <p className={`card-title ${props.styles.cardHeading}`}>Tags</p> */}
              <p>Tags</p>
              <div
                style={{
                  padding: "10px",
                }}
              >
                {article?.tag?.map((obj) => {
                  return (
                    <>
                      <span
                        style={{
                          color: "white",
                          backgroundColor: "#77ac54",
                          padding: "10px",
                          borderRadius: "5px",
                        }}
                      >
                        {obj.name}
                      </span>
                      &nbsp;
                    </>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="fs-5 mb-2">
            {/* <p className={`card-title ${props.styles.cardHeading}`}> */}
            <h3>Description</h3>
            <div
              style={{
                padding: "10px",
              }}
            >
              <p
                className="lead"
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  textAlign: "justify",
                }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: article?.article_text,
                  }}
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlogDetailSection;
